module.exports = __webpack_public_path__ + "static/img/subwxpic.d9637f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subwxpic.png
// module id = 3n5n
// module chunks = 43